import { useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { Network, Search, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SignInDialog } from "@/components/Auth/SignInDialog";
import { useAuthStore } from "@/stores/authStore";
import { signOut, API_BASE } from "@/lib/api";
import { toast } from "@/hooks/useToast";

export function RootLayout() {
  const [signInOpen, setSignInOpen] = useState(false);
  const { isSignedIn, signOut: storeSignOut } = useAuthStore();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut(API_BASE);
    storeSignOut();
    void navigate("/");
    toast({ title: "Signed out" });
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b bg-background sticky top-0 z-40">
        <div className="container mx-auto px-4 h-14 flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 font-semibold text-lg"
          >
            <Network className="h-5 w-5" />
            Tabgraph
          </Link>

          <nav className="flex items-center gap-2 ml-4">
            <Button variant="ghost" size="sm" asChild>
              <Link to="/sessions">Sessions</Link>
            </Button>
            <Button variant="ghost" size="sm" asChild>
              <Link to="/search">
                <Search className="h-4 w-4 mr-1" />
                Search
              </Link>
            </Button>
          </nav>

          <div className="ml-auto flex items-center gap-2">
            {isSignedIn ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <Settings className="h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem asChild>
                    <Link to="/settings">Settings</Link>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem
                    onClick={() => { void handleSignOut(); }}
                    className="text-destructive"
                  >
                    Sign out
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <Button size="sm" onClick={() => setSignInOpen(true)}>
                Sign in
              </Button>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <SignInDialog open={signInOpen} onOpenChange={setSignInOpen} />
    </div>
  );
}
